module.exports = __webpack_public_path__ + "media/icons/plus-2c26d884.svg";